export const formatCurrency = (value?: number | null, currency = "SEK", maximumSignificantDigits = 8) => {
  if (!value) return "0";
  return new Intl.NumberFormat("sv-SE", {
    style: "currency",
    currency,
    maximumSignificantDigits,
  }).format(value);
};
